<template>
    <div class="header-challenge-results">
        <div class="header-challenge-results__heading">
            <h2>MEYDAN OKUMA</h2>
            <h1>Sonuçlar</h1>
        </div>
        <div class="header-challenge-results__tabs">
            <button
                class="btn-tab-stats"
                :class="currentTab === 'stats' ? 'btn-tab--current' : '' "
                @click="updateParentCurrentTab('stats')">
                <span class="btn-tab-stats__text">İstatistikler</span>
            </button>
            <button
                class="btn-tab-challenge"
                :class="currentTab === 'challenge' ? 'btn-tab--current' : '' "
                @click="updateParentCurrentTab('challenge')">
                <span class="btn-tab-challenge__text">Karşılaşma</span>
            </button>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            currentTab: {
                type: String,
                default: 'stats',
            },
        },

        methods: {
            updateParentCurrentTab(currentTab){
                this.$parent.$data.currentTab = currentTab;
            }
        }
    };
</script>

<style scoped src="@/css/components/header-challenge-results.css"></style>